import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { Place, TowelVariant } from 'types/products'
import { placeFilterFn } from 'utils'
import { sizeSortingFn, useProductTable } from './ProductTable'

type Props = {
  variants: Array<TowelVariant>
  highlightItemId?: string
}

export default function TowelTable({ variants, highlightItemId }: Props) {
  const columns = useMemo<Array<MRT_ColumnDef<TowelVariant>>>(
    () => [
      {
        accessorKey: 'size',
        header: 'Wymiar',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wymiarze',
        },
        sortingFn: sizeSortingFn,
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        filterFn: placeFilterFn,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po półce',
        },
      },
      {
        accessorKey: 'feature',
        header: 'Cecha',
        enableSorting: false,
        size: 120,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po cesze',
        },
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        size: 120,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )
  const table = useProductTable({
    columns,
    data: variants,
    highlightItemId,
  })
  return <MantineReactTable table={table} />
}
